export default __webpack_public_path__ + "static/media/netflix.0153bdee.svg";